// Section 'Team slider' Javascript
// tamaragency.com

function initTeamSlider(container) {
  const names = container.querySelectorAll('.team-name');
  const cards = container.querySelectorAll('.team-card');

  if (!names.length || !cards.length) return;

  names.forEach((name) => {
    name.addEventListener('mouseenter', () => {
      const member = name.dataset.member;
      cards.forEach((card) => card.classList.remove('active'));
      names.forEach((n) => n.classList.remove('active'));
      name.classList.add('active');

      const activeCard = container.querySelector(`.team-card[data-member="${member}"]`);
      if (activeCard) {
        activeCard.classList.add('active');
      }
    });
  });

  cards[0].classList.add('active');
  names[0].classList.add('active');
}

function initAllTeamSliders() {
  document.querySelectorAll('[data-team-slider]').forEach((slider) => {
    initTeamSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', initAllTeamSliders);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-team-slider]')) {
    initAllTeamSliders();
  }
});

document.addEventListener('shopify:section:select', (event) => {
  if (event.target.querySelector('[data-team-slider]')) {
    initAllTeamSliders();
  }
});